import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import {ThemeList} from "./themeList";
import { getGreenTheme } from "./greenTheme";
import {getBlueTheme} from "./blueTheme";
import {getGrayTheme} from "./grayTheme";
import {getWhiteTheme} from "./whiteTheme";
import {getBankNizwaTheme} from './bankNizwaTheme'
const getTheme = (theme) => {
  let themeObject;

  if(process.env.REACT_APP_FORCE_THEME !== undefined && process.env.REACT_APP_FORCE_THEME !== "") {
    theme = process.env.REACT_APP_FORCE_THEME;
  }
console.log("Theme",theme)
  switch (theme) {
    case ThemeList.BankNizwa:
      themeObject = getBankNizwaTheme();
      break;
    case ThemeList.Blue:
      themeObject = getBlueTheme();
      break;
    case ThemeList.Gray:
      themeObject = getGrayTheme();
      break;
    case ThemeList.White:
      themeObject = getWhiteTheme();
      break;
    default:
      themeObject = getGrayTheme();
  }

  const Theme = createTheme(themeObject);
  return responsiveFontSizes(Theme);
};
export default getTheme;
